export default {
  title: 'Pourquoi régénérer cette image ?',
  description: "Aidez-nous à améliorer l'IA en nous indiquant ce qui n'allait pas.",
  reasons: {
    wrong_style: 'Style incorrect',
    wrong_colors: 'Couleurs incorrectes',
    wrong_food_item: 'Plat incorrect',
    low_quality: 'Qualité insuffisante',
    doesnt_match_brand: 'Ne correspond pas à ma marque',
    text_issues: 'Texte ou étiquettes incorrects',
    other: 'Autre',
  },
  details_label: 'Autre chose ? (facultatif)',
  details_placeholder: 'Ajoutez des détails pour nous aider à comprendre…',
  cancel: 'Annuler',
  confirm: 'Régénérer',
};
